import { render, staticRenderFns } from "./deleteMessage.vue?vue&type=template&id=4c73bc25&scoped=true&"
import script from "./deleteMessage.vue?vue&type=script&lang=js&"
export * from "./deleteMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73bc25",
  null
  
)

export default component.exports